import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { addTestAutomationClassName } from 'utils/misc'

import TransitionPage from 'containers/TransitionPage'
import BackButton from 'components/atoms/buttons/BackButton'
import ChangePasswordForm from 'components/organisms/ChangePasswordForm'

export const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    ...theme.components.accountPage,
  },
  subtitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  backButton: {
    ...theme.components.backButton,
  },
})

const EnterPassword = ({
  classes,
  errorMessage,
  onBackPress,
  onPasswordSubmit,
  hasError,
}) => (
  <TransitionPage>
    <div className={classes.root}>
      <Typography variant="h1">Change password</Typography>
      <ChangePasswordForm
        onPasswordSubmit={onPasswordSubmit}
        apiCallError={hasError}
        errorMessage={errorMessage}
      />
      <BackButton
        className={classNames(
          classes.backButton,
          addTestAutomationClassName('qa-changepassword-button-back')
        )}
        onPress={onBackPress}
      />
    </div>
  </TransitionPage>
)

EnterPassword.propTypes = {
  hasError: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onBackPress: PropTypes.func,
  errorMessage: PropTypes.string,
  onPasswordSubmit: PropTypes.func,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(EnterPassword)



// WEBPACK FOOTER //
// ./src/containers/account/ChangePassword/ChangePassword.js